<div #scaleDiv style="transform-origin: left top; position: relative;" class="manipulative-container">
  <ng-content></ng-content>
</div>